import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../components/apiconfig/api-config';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import backgroundImage1 from '../../assets/img-login-1.png';
import backgroundImage2 from '../../assets/img-login-2.png';
import backgroundImage3 from '../../assets/img-login-3.png';
import backgroundImage4 from '../../assets/img-login-4.jpg';
import ctmsLogo from '../../assets/ctms-logo.png';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Array of background images
  const backgroundImages = [
    backgroundImage1,
    backgroundImage2,
    backgroundImage3,
    backgroundImage4
  ];



  // Image slideshow effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === backgroundImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [backgroundImages.length]);


  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await axios.post(
        `${API_BASE_URL}/api/auth/login`,
        { email, password },
        { withCredentials: true }
      );
      toast.success('Login successful!', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
      setTimeout(() => {
        navigate('/dashboard');
      }, 1200);
    } catch (err) {
      const msg =
        err.response?.data?.error ||
        err.message ||
        'Login failed. Please try again.';
      toast.error(msg, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
      setIsLoading(false);
    }
  };

  return (
    <>
      <ToastContainer 
        toastClassName={() =>
          'relative flex items-center p-4 min-h-12 rounded-xl justify-between overflow-hidden cursor-pointer bg-[#15803d]/90 text-white text-[14px] font-semibold shadow-lg backdrop-blur-sm border border-[#15803d]/30'
        }
      />
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#f0fdf4] to-[#dcfce7] p-4 md:p-8">
        
        {/* Main Card */}
        <div className="flex flex-col md:flex-row w-full max-w-5xl bg-white rounded-[2rem] shadow-2xl overflow-hidden min-h-[600px]">
          
          {/* Left Side - Image Slideshow */}
          <div className="hidden md:flex w-1/2 relative p-4">
            {/* Inner rounded container for images */}
            <div className="w-full h-full relative rounded-2xl overflow-hidden shadow-inner">
              {backgroundImages.map((image, index) => (
                <div 
                  key={index}
                  className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${index === currentImageIndex ? 'opacity-100 scale-105' : 'opacity-0 scale-100'}`}
                  style={{ backgroundImage: `url("${image}")`, transitionProperty: 'opacity, transform', transitionDuration: '3s, 10s', transitionTimingFunction: 'ease-out' }}
                />
              ))}
            </div>
          </div>

          {/* Right Side - Login Form */}
          <div className="flex flex-col justify-center items-center w-full md:w-1/2 p-8 md:p-12 bg-white">
            <div className="w-full max-w-sm">
              
              {/* Logo matching Yeti Screenshot style */}
              <div className="text-center mb-8">
                <div className="flex flex-col items-center justify-center mb-5">
                  <img src={ctmsLogo} alt="CTMS Logo" className="w-48 md:w-56 h-auto object-contain drop-shadow-sm" />
                </div>
                <h2 className="text-[1.7rem] font-black text-gray-900 uppercase tracking-tight mb-1.5">Welcome Back</h2>
                <p className="text-[12px] text-gray-500 font-medium">Enter your email and password to access your account</p>
              </div>

              {/* Form */}
              <form onSubmit={handleLogin} className="space-y-4">
                {/* Email Input */}
                <div>
                  <label className="block text-[12px] font-bold text-gray-700 mb-1.5" htmlFor="email">
                    Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    autoFocus
                    className="w-full px-5 py-2.5 bg-[#f3f4f6] border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-[#15803d]/50 text-gray-900 placeholder-gray-400 transition-all duration-200"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                  />
                </div>

                {/* Password Input */}
                <div>
                  <label className="block text-[12px] font-bold text-gray-700 mb-1.5" htmlFor="password">
                    Password
                  </label>
                  <input
                    id="password"
                    type="password"
                    className="w-full px-5 py-2.5 bg-[#f3f4f6] border-none rounded-xl focus:outline-none focus:ring-2 focus:ring-[#15803d]/50 text-gray-900 placeholder-gray-400 transition-all duration-200"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    required
                  />
                </div>

                {/* Options Row */}
                <div className="flex items-center justify-between px-1 pt-1 pb-2">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" className="w-4 h-4 rounded border-gray-300 text-[#15803d] focus:ring-[#15803d]" />
                    <span className="text-[12px] text-gray-600 font-medium">Remember me</span>
                  </label>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`w-full py-2.5 px-4 text-white text-[0.95rem] font-bold rounded-xl ${
                    isLoading ? 'bg-gray-800 opacity-80 cursor-not-allowed' : 'bg-[#15803d] hover:bg-[#166534] shadow-md hover:shadow-lg transition-all duration-200'
                  } flex items-center justify-center mt-2`}
                >
                  {isLoading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Signing in...
                    </>
                  ) : 'Sign In'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;